<div class="page-wrapper">
  <div class="middle-container">
    <qai-inner-wrap>
      <div class="sim-header">
        <div class="simulation-heading">
          <h2 class="heading">{{ 'simulationBuilder.SIMULATION_BUILDER_HEADING' | transloco }}</h2>
          <div>
            <qai-floating-select
              *ngIf="!hasSingleEligibleAccount"
              [options]="options"
              [placeholder]="'Select an option'"
              [placement]="'below-start'"
              [offset]="4"
              [shape]="'round'"
              [value]="selectedAccount?.value"
              (valueChange)="valueChange($event)"
              (selectionChange)="selectionChange($event)"
            ></qai-floating-select>
          </div>
        </div>

        <!-- Create buttons based on selected account roles -->
        <button-floating-select
          *ngIf="
            selectedAccountHasAssignmentManager && selectedAccountHasAuthor
          "
          [options]="createModuleOptions"
          [buttonLabel]="'simulationBuilder.ACTION_CREATE_NEW' | transloco"
          buttonIcon="plus"
          (optionSelected)="handleCreateOptions($event)"
        ></button-floating-select>

        <button
          *ngIf="
            selectedAccountHasAssignmentManager && !selectedAccountHasAuthor
          "
          qai-button
          [shape]="'normal'"
          [kind]="'primary'"
          [size]="'medium'"
          (click)="openAssignmentModal()"
        >
          <qai-icon kind="plus" positionStart />
          {{ 'simulationBuilder.CREATE_NEW_ASSIGNMENT_BUTTON' | transloco }}
        </button>

        <button
          #createSimulationButton
          qai-button
          *ngIf="
            selectedAccountHasAuthor && !selectedAccountHasAssignmentManager
          "
          [shape]="'normal'"
          [kind]="'primary'"
          [size]="'medium'"
          (click)="openModal(EntityType.SIMULATION, EntityActionType.CREATE)"
        >
          <qai-icon kind="plus" positionStart />
          {{ 'simulationBuilder.CREATE_NEW_SIMULATION_BUTTON' | transloco }}
        </button>
      </div>

      <qai-tabs
        (tabSelected)="onTabChange($event)"
        *ngIf="shouldShowTabs"
      >
        <ng-template qaiTab="uniqueId1" [label]="'simulationBuilder.ASSIGNMENTS_TAB_LABEL' | transloco">
          <app-assignments
            [selectedAccount]="selectedAccount"
            [selectedAccountUuid]="selectedAccountUuid"
            (deleteAssignment)="onDeleteItem(EntityType.ASSIGNMENT, $event)"
            (duplicateAssignment)="onDuplicateAssignment($event)"
            (changeAssignmentStatus)="handleChangeAssignmentStatus($event)"
          ></app-assignments>
        </ng-template>

        <ng-template qaiTab="uniqueId2" [label]="'simulationBuilder.SIMULATIONS_TAB_LABEL' | transloco">
          <app-assignment-simulations
            [selectedAccount]="selectedAccount"
            [selectedAccountUuid]="selectedAccountUuid"
            (deleteSimulation)="onDeleteItem(EntityType.SIMULATION, $event)"
            (duplicateSimulation)="onDuplicateSimulation($event)"
            (archiveSimulation)="onArchiveSimulation($event)"
            (openGenerationModal)="handleOpenGenerationModal($event)"
            [refreshKey]="simulationsRefreshKey"
          ></app-assignment-simulations>
        </ng-template>

        @if (shouldShowUsersTab) {
          <ng-template qaiTab="uniqueId3" [label]="'simulationBuilder.USERS_TAB_LABEL' | transloco">
            <app-users-list
              [users]="fetchedUsers"
              [isLoading]="isUsersLoading"
            />
          </ng-template>
        }
      </qai-tabs>

      <!-- Show only Simulations tab -->
      <div *ngIf="!shouldShowAssignmentsTab && shouldShowSimulationsTab && !shouldShowUsersTab">
        <app-assignment-simulations
          [selectedAccount]="selectedAccount"
          [selectedAccountUuid]="selectedAccountUuid"
          (deleteSimulation)="onDeleteItem(EntityType.SIMULATION, $event)"
          (duplicateSimulation)="onDuplicateSimulation($event)"
          (archiveSimulation)="onArchiveSimulation($event)"
          (openGenerationModal)="handleOpenGenerationModal($event)"
          [refreshKey]="simulationsRefreshKey"
        ></app-assignment-simulations>
      </div>

      <div *ngIf="shouldShowAssignmentsTab && !shouldShowSimulationsTab && !shouldShowUsersTab">
        <app-assignments
          [selectedAccount]="selectedAccount"
          [selectedAccountUuid]="selectedAccountUuid"
          (deleteAssignment)="onDeleteItem(EntityType.ASSIGNMENT, $event)"
          (duplicateAssignment)="onDuplicateAssignment($event)"
          (changeAssignmentStatus)="handleChangeAssignmentStatus($event)"
        ></app-assignments>
      </div>

      <!-- Show only Users tab (standalone) -->
      <div *ngIf="shouldShowUsersTab && !shouldShowAssignmentsTab && !shouldShowSimulationsTab">
        <app-users-list
          [users]="fetchedUsers"
          [isLoading]="isUsersLoading"
        />
      </div>
    </qai-inner-wrap>
  </div>
</div>

<assignment-modal
  [open]="isAssignmentModalVisible"
  (assignmentSave)="handleAssignmentSave($event, true)"
  (handleSaveAndClose)="handleAssignmentSave($event, false)"
  (closeAssignmentModal)="closeAssignmentModal()"
  [networkRequestInProgress]="assignmentRequestInProgress"
></assignment-modal>

<action-modal
  [open]="modalOpen"
  [entityType]="modalEntityType"
  [entityActionType]="modalActionType"
  [originalName]="modalOriginalName"
  [networkRequestInProgress]="networkRequestInProgress"
  [errorStatus]="modalErrorStatus"
  (confirmAction)="onModalConfirmed($event)"
  (closeModal)="closeModal()"
></action-modal>

<self-authoring-simulation-generation-modal
  [open]="selfAuthoringCreateModalOpen"
  [activeCallUuid]="selfAuthoringCreateCallUuid"
  [moduleUuid]="moduleUuid"
  [networkRequestInProgress]="networkRequestInProgress"
  [errorStatus]="modalErrorStatus"
  [isFilesExceedingTokens]="isFilesExceedingTokens"
  [prefillData]="selfAuthoringPrefillData"
  [retryInProgress]="retryInProgress"
  [simulationType]="selfAuthoringSimulationType"
  (confirmAction)="handleSelfAuthoringConfirmed($event)"
  (closeModal)="closeSelfAuthoringCreateModal()"
  (generationClosed)="handleSelfAuthoringGenerationClosed()"
  (backToFormWithPrefill)="handleBackToFormWithPrefill()"
  (retryClicked)="handleRetryClicked()"
></self-authoring-simulation-generation-modal>

<simulation-type-selection-modal
  [open]="simulationTypeSelectionModalOpen"
  (typeSelected)="handleSimulationTypeSelected($event)"
  (dismissed)="handleSimulationTypeSelectionDismissed()"
></simulation-type-selection-modal>

<delete-modal
  [open]="isDeleteModalOpen"
  (openChange)="isDeleteModalOpen = $event"
  (confirm)="handleDeleteConfirmed()"
  (closeModal)="closeDeleteModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  [type]="deleteContext?.type || EntityType.ASSIGNMENT"
  [assignmentStatus]="assignmentStatusLabel"
  [moduleUuid]="deleteContext?.moduleUuid"
></delete-modal>

<add-simulation-to-assignment-modal
  [open]="addSimulationsToAssignmentModalOpen"
  (backAndCloseModal)="closeAddSimulationAndOpenAssignmentModal()"
  (closeSimulationModal)="closeAddSimulationToAssignmentModal()"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  [moduleUuid]="moduleUuid"
  (simulationAssigned)="handleSimulationAssigned()"
  [modalHeading]="'simulationBuilder.CREATE_NEW_ASSIGNMENT_BUTTON' | transloco"
  [isCreateAssignmentFlow]="true"
></add-simulation-to-assignment-modal>

<add-users-to-assignment-modal
  [open]="isUserAssignmentModalVisible"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  (closeModal)="closeUserAssignmentModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  (addToAssignmentClicked)="handlePostUserAssignmentModal()"
  [currentAssignees]="newAssignmentCurrentAssignees"
  [isCreateAssignmentFlow]="true"
></add-users-to-assignment-modal>
